import { useMutation, type UseMutationResult } from "@tanstack/react-query";
import notification from "@app/services/notification";
import type { UseBusinessListQueryResult } from "@src/hooks/useBusinessListQuery";
import { wsInplantsApi, type ApiWsInplant, type WsInplant, type WsInplantFilter } from "../../../../api/wsInplants";
import {
    wsInplantInsertToApi,
    type WsInplantInsertFormValues,
} from "./components/WsInplantsInsert/wsInplantInsert.form-config";

function apiWsInplantToListItem(apiInplant: ApiWsInplant): WsInplant {
    return {
        Code: apiInplant.Code,
        Num: apiInplant.Num,
        DocDate: apiInplant.DocDate,
        LeaveMoveDate: apiInplant.LeaveMoveDate,
        ArrivalMoveDate: apiInplant.ArrivalMoveDate,
        SenderCode: apiInplant.Sender,
        SenderSectionCode: apiInplant.SenderSection,
        ReceiverCode: apiInplant.Receiver,
        ReceiverSectionCode: apiInplant.ReceiverSection,
        Bo: { StateCode: apiInplant.bo.State },
    };
}

export interface WsInplantCreateMutationVariables {
    values: WsInplantInsertFormValues;
}

interface UseWsInplantsListMutationsParams {
    list: UseBusinessListQueryResult<WsInplant, WsInplantFilter>;
}

export interface UseWsInplantsListMutationsResult {
    createMutation: UseMutationResult<ApiWsInplant, Error, WsInplantCreateMutationVariables>;
}

export function useWsInplantsListMutations({ list }: UseWsInplantsListMutationsParams): UseWsInplantsListMutationsResult {
    const createMutation = useMutation({
        mutationKey: ["wsInplants", "create"],
        meta: { errorSource: "wsInplants.create" },
        mutationFn: ({ values }: WsInplantCreateMutationVariables) => wsInplantsApi.insert(wsInplantInsertToApi(values)),
        onSuccess: (created, { values }) => {
            if (values.num !== created.Num) {
                notification.warning(`Номер документа "${values.num}" не уникален. Номер был изменён на "${created.Num}"`);
            }

            if (list.filter != null) {
                list.mutate.createItem(apiWsInplantToListItem(created));
            }
        },
    });

    return { createMutation };
}
